import { SignalRService } from './signalR.service';
import { IChatCommand } from './models/chat-command';
import { TopLevelComponent, User } from '../shared/models';
import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { ChatService } from './chat.service';
import { UserService, Store, StoreHelper  } from '../shared/services';
import { Observable } from 'rxjs/Observable';

@Component({
    template: `<router-outlet></router-outlet>`,
})
export class ChatComponent  extends TopLevelComponent implements OnDestroy, OnInit {

   connectionState$: Observable<string>;

   // subscriptions
   private commandsSubscription: Subscription;
   private userSubscription: Subscription;

   private _user: User;

   constructor( private _router: Router,
                storeHelper: StoreHelper,
                store: Store,
                userService: UserService,
                private _chatService: ChatService,
                private signalRService: SignalRService,
                private _ngZone: NgZone
                ) {
     super(store, storeHelper, userService);
  }

  ngOnInit() {
      this.commandsSubscription = this._subscribeToChatCommands();
      this.userSubscription = this.userService.user$.subscribe(user => {
          this._user = user;
      });

      this.signalRService.connect();
  }

  ngOnDestroy() {
      this.commandsSubscription.unsubscribe();
      this.userSubscription.unsubscribe();
  }

  private _subscribeToChatCommands(): Subscription {
     return this._chatService.commandBus$
      .subscribe((chatCommand: IChatCommand) => this._processChatCommands(chatCommand));
  }

  private _processChatCommands(chatCommand: IChatCommand) {
      switch (chatCommand.id) {
           case 'openThread':
              this._chatService.joinRegion(chatCommand.data.region);
              this.signalRService.joinRegion(chatCommand.data.region);
              this._router.navigate(['chat/messages']);
              break;

          case 'joinRegion':
              this._chatService.joinRegion(chatCommand.data);
              this.signalRService.joinRegion(chatCommand.data);
              this._router.navigate(['chat/messages']);
              break;

          case 'sendMessageToSignalR':
              this.signalRService.sendChatMessageToRegion(chatCommand.data.region, chatCommand.data.text, chatCommand.data.timestamp);
              break;

          case 'displayReceivedMessage':
                  this._ngZone.run(() => {
                      this._chatService.proccessIncomingMessage(chatCommand.data);
                  });
              break;

          default:
          return;
      }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/chat/chat.component.ts